export default __webpack_public_path__ + "static/about-1-ec37ee17ce384c6f4b967189acc43641.jpg";